import React from 'react';
import { Button } from 'react-bootstrap';

export const AmazonDailySalesScreen = (props) => {
  let headers = '';
  let text = '';
  if (props.amazonReportOutput) {
    const id = Object.keys(props.amazonReportOutput)[0];
    const order = props.amazonReportOutput[id];
    headers = id ? Object.keys(order) : '';

    text = Object.values(props.amazonReportOutput).map((sale, saleIndex) => {
      return headers.map((header, index) => {
        if (index === 0 && saleIndex !== 0) {
          return '\n' + sale[header];
        } else {
          return sale[header];
        }
      });
    });
  }

  //create array of dates
  const dates = {};
  Object.values(props.amazonReportOutput).forEach((order) => {
    dates[order.purchaseDate.slice(0, 10)] = [];
  });
  Object.values(dates).map((date) => {
    Object.values(props.amazonReportOutput).forEach((order) => {
      if (dates[order.purchaseDate.slice(0, 10)] === date) {
        dates[order.purchaseDate.slice(0, 10)].push(order);
      }
    });
  });

  const productsWithNoCost = [];

  //add summary data to date array
  Object.values(dates).map((date) => {
    date.totalNetProfit = 0;
    date.totalExVatSales = 0;
    date.totalExVatSalesIncProductsWithNoCost = 0;
    date.forEach((order) => {
      if (order.netProfit) {
        date.totalNetProfit = date.totalNetProfit + order.netProfit;
        date.totalExVatSales = date.totalExVatSales + order.totalSalePrice;
      }
      if (!order.netProfit) {
        productsWithNoCost.push(order);
      }
      date.totalExVatSalesIncProductsWithNoCost =
        date.totalExVatSalesIncProductsWithNoCost + parseFloat(order.exVatSalePrice);
    });
    date.marginOnKnownProducts = date.totalNetProfit / date.totalExVatSales;
    date.totalEstimatedProfit = date.marginOnKnownProducts * date.totalExVatSalesIncProductsWithNoCost;
  });

  const output = headers + '\n' + text;

  //output for textarea box
  console.log('test', dates)

  const summary = Object.entries(dates).map((key) => {
    return `${key[0]}: ${(key[1].marginOnKnownProducts * 100).toFixed(
      2,
    )}% £${key[1].totalExVatSalesIncProductsWithNoCost.toFixed(2)} £${(
      key[1].totalExVatSalesIncProductsWithNoCost * key[1].marginOnKnownProducts
    ).toFixed(2)}\n`;
  });

  return (
    <div>
      <div>
        <h2>Paste Amazon Sales Report</h2>
      </div>
      <textarea onChange={(e) => props.setAmazonReport(e.target.value)} value={props.amazonReport}></textarea>
      <div>
        <Button onClick={props.handleOnSubmit}>Submit</Button>
      </div>
      {Object.keys(dates).length > 0 && (
        <div>
          <div>
            <h3>Order Data</h3>
          </div>
          <textarea value={output}></textarea>
          <div>
            <h3>Summary</h3>
          </div>
          <textarea value={'Date Margin Sales Profit\n' + summary.reverse().join('')}></textarea>
          {productsWithNoCost.length > 0 && (
            <div>
              <div>
                <h3>
                  These orders are not included in the margin calculation as they have no product cost. Their sales
                  value is included:
                </h3>
              </div>
              {productsWithNoCost.map((order) => {
                return (
                  <div>
                    {order.sku}: {order.asin}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
